import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { TableCell, TableRow } from "@/ds/shadcn/components/ui/table";
import { cn } from "@/ds/utils";
import { useInfiniteScroll } from "@/lib/common/useInfiniteScroll";
import type { PaginatedResponseModel, ProblemResponse } from "@/lib/http";
import type { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";
import { useRef, type RefObject } from "react";

export interface ListInfiniteScrollerProps<T> {
	forQuery: UseInfiniteQueryResult<InfiniteData<PaginatedResponseModel<T>>, ProblemResponse>;
	colSpan: number;
	scrollRef?: RefObject<HTMLElement | null>;
}

export const ListInfiniteScroller = <T,>(props: ListInfiniteScrollerProps<T>): React.JSX.Element => {
	const {
		forQuery,
		colSpan,
		scrollRef
	} = props;

	const ref = useRef<HTMLDivElement | null>(null);
	const showSpinner = useInfiniteScroll(ref, forQuery, scrollRef);

	return (
		<TableRow className={cn(!showSpinner && "hidden")}>
			<TableCell colSpan={colSpan}>
				<div ref={ref} className="flex justify-center p-3">
					<Spinner />
				</div>
			</TableCell>
		</TableRow>
	);
};
